'use client';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { signIn, signOut } from 'next-auth/react';
import {
  Form,
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from '@/components/ui/form';
import { zodResolver } from '@hookform/resolvers/zod';
import { useForm } from 'react-hook-form';
import { z } from 'zod';
import { toast } from './ui/use-toast';

const formSchema = z.object({
  agentId: z.string(),
});

export default function SwitchAgentIDForm({
  onSuccess,
}: {
  onSuccess: () => void;
}) {
  const form = useForm<z.infer<typeof formSchema>>({
    resolver: zodResolver(formSchema),
    defaultValues: {
      agentId: '',
    },
  });

  async function onSubmit({ agentId }: z.infer<typeof formSchema>) {
    form.clearErrors();
    signIn('mip-auth', {
      agentId,
      redirect: false,
    })
      .then((response) => {
        if (!response?.ok) {
          form.setError('agentId', {
            type: 'manual',
            message: 'Writing code not found, please try again',
          });
          return;
        }
        onSuccess();
        toast({ title: 'Writing code successfully updated.' });
      })
      .catch((reason) => {
        form.setError('agentId', {
          type: 'manual',
          message: 'Failed to sign user in',
        });
        console.error('failed to sign user in', reason);
        signOut();
      });
  }

  return (
    <Form {...form}>
      <form
        onSubmit={form.handleSubmit(onSubmit)}
        className="flex flex-col gap-9"
      >
        <FormField
          control={form.control}
          name="agentId"
          render={({ field }) => (
            <FormItem>
              <FormLabel className="text-blue-900">Writing code</FormLabel>
              <FormControl>
                <Input id="agentId" {...field} />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
        <div className="pt-7 border-t border-olive-400">
          <Button
            className="flex ml-auto"
            type="submit"
            data-ta="switch-agent-id-submit"
            disabled={form.formState.isSubmitting}
          >
            Submit
          </Button>
        </div>
      </form>
    </Form>
  );
}
